module.exports = __webpack_public_path__ + "img/icon_l_jg.ed0231d0.png";